export default class PlayerBridge {

    setImplementation(implementation){
        this._implementation = implementation;
    }
    initPlayer(options) {
        this._implementation.initPlayer(options);
    }
    play(){
        this._implementation.play();
    }
    stop(){
        this._implementation.stop();
    }
    async getDuration(){
        return await this._implementation.getDuration();
    }
}



// WEBPACK FOOTER //
// ./components/responsive-video/scripts/players/player-bridge.js